
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M11.2 14.4V11.7H13.9V9.69995H11.2V7H9.19995V9.69995H6.5V11.7H9.19995V14.4H11.2Z"></path><path d="M10.2 2.5C5.67126 2.5 2 6.17126 2 10.7C2 15.2287 5.67126 18.9 10.2 18.9C14.7287 18.9 18.4 15.2287 18.4 10.7C18.4 6.17126 14.7287 2.5 10.2 2.5ZM4 10.7C4 7.27583 6.77583 4.5 10.2 4.5C13.6242 4.5 16.4 7.27583 16.4 10.7C16.4 14.1242 13.6242 16.9 10.2 16.9C6.77583 16.9 4 14.1242 4 10.7Z"></path><path d="M22.4141 21.5001L17.3999 16.4858L15.9857 17.9001L20.9999 22.9143L22.4141 21.5001Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiMousezoominFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
